import { GetRequest } from "../../../common/api"
import { urls } from "../../../common/constants"

export const columnDefs = [
    { header: 'Gen. Date Time', dataKey: 'GeneratedDateTime', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '7%', textAlign: 'left' } },
    { header: 'LRNO', dataKey: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '13%', textAlign: 'left' } },
    { header: 'Challan No.', dataKey: 'ChallanNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '6%', textAlign: 'left' } },
    { header: 'Source City', dataKey: 'FromCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '8%', textAlign: 'left' } },
    { header: 'Source Branch', dataKey: 'FromBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '12%', textAlign: 'left' } },
    { header: 'ToPay Quantity', dataKey: 'TotalItems', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '6%', textAlign: 'right' } },
    { header: 'ToPay Amount', dataKey: 'TopayAmt', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '6%', textAlign: 'right' } },
    { header: 'Details', dataKey: 'details', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '5%', textAlign: 'center' } },
    { header: 'Is Received', dataKey: 'IsReceived', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '7%', textAlign: 'center' } },
    { header: 'Remarks', dataKey: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '25%', textAlign: 'left' } },
]
export const columnDefsForExcel = [
    { header: 'Generated Date Time', dataKey: 'GeneratedDateTime', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx: { cellWidth: 131.11 }, weight: 75 },
    { header: 'LRNO', dataKey: 'LRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx: { cellWidth: 131.11 }, weight: 81 },
    { header: 'Challan No.', dataKey: 'ChallanNo', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx: { cellWidth: 131.11 }, weight: 67 },
    { header: 'Source City', dataKey: 'FromCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx: { cellWidth: 131.11 }, weight: 80 },
    { header: 'Source Branch', dataKey: 'FromBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '13%', textAlign: 'left' }, pdfColSx: { cellWidth: 131.11 }, weight: 100 },
    { header: 'ToPay Quantity', dataKey: 'TotalItems', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { width: '7%', textAlign: 'right' }, pdfColSx: { cellWidth: 131.11 }, weight: 75 },
    { header: 'ToPay Amount', dataKey: 'TopayAmt', xlCol: { dataType: 'number', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'right' }, pdfColSx: { cellWidth: 131.11 }, weight: 80 },
    // { header: 'Details', dataKey: 'details', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'center' }, pdfColSx:{cellWidth: 131.11} },
    { header: 'Is Received', dataKey: 'IsReceived', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '8%', textAlign: 'center' }, pdfColSx: { cellWidth: 131.11 }, weight: 50 },
    { header: 'Remarks', dataKey: 'Remarks', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx: { cellWidth: 131.11 }, weight: 81 },
]

export const headerColDefs = [
    { header: 'From Date', dataKey: 'fromDate', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'To Date', dataKey: 'toDate', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Source City', dataKey: 'srcCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Source Branch', dataKey: 'srcBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Destination City', dataKey: 'destCity', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Destination Branch', dataKey: 'destBranch', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
    { header: 'Status', dataKey: 'status', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' } },
  
]
export const tblData = [
    {
        isSubHeading: true, dateTime: 'Destination: Ahmednagar - HO_Royal Tourist Services', toPayData: [
            { isDataRow: true, dateTime: '05-02-2025', LRNO: 'MAHD/24-25/6448', challan: '1049', srcCity: 'Nagpur', srcBranch: 'Saini Wadi', qty: '9', amount: '2142', isReceived: 0, remarks: 'test' },
            { isDataRow: true, dateTime: '05-02-2025', LRNO: 'MAHD/24-25/6448', challan: '1049', srcCity: 'Nagpur', srcBranch: 'Saini Wadi', qty: '9', amount: '2142', isReceived: 0, remarks: 'test' },
            { isTotalRow: true, dateTime: 'Total', qty: '9', amount: '2142' },
        ]
    },
    {
        isSubHeading: true, dateTime: 'Destination: Ahmednagar - HO_Royal Tourist Services', toPayData: [
            { isDataRow: true, dateTime: '05-02-2025', LRNO: 'MAHD/24-25/6448', challan: '1049', srcCity: 'Nagpur', srcBranch: 'Saini Wadi', qty: '9', amount: '2142', isReceived: 0, remarks: 'test' },
            { isDataRow: true, dateTime: '05-02-2025', LRNO: 'MAHD/24-25/6448', challan: '1049', srcCity: 'Nagpur', srcBranch: 'Saini Wadi', qty: '9', amount: '2142', isReceived: 0, remarks: 'test' },
            { isTotalRow: true, dateTime: 'Total', qty: '9', amount: '2142' },
        ]
    },
]

export const statusList = [{id:-1, name:'All'},{id:0, name:'Unpaid'},{id:1, name:'Paid'},]

export const getFranchiseePendingTopayData = async (body, setAlert) => {
  try {
    const res = await GetRequest(urls.getFrchseeToPayPending, body)

    if (res.status !== 'Success') {
      setAlert({ show: true, msg: res?.ErrMessage, nextId: '' })
      return
    }

    const tableData = res?.Data?.Table || []

    if (tableData.length === 0) {
      setAlert({ show: true, msg: 'No Data Found', nextId: '' })
      return
    }

    return groupData(tableData)
  } catch (error) {
    setAlert({ show: true, msg: error?.message, nextId: '' })
  }
}

export const groupData = (data) => {
    const groupedData = {};

    data.forEach(item => {
        const key = `${item.ToCityID}-${item.ToBranchID}`;

        if (!groupedData[key]) {
            groupedData[key] = {
                isSubHeading: true,
                GeneratedDateTime: `Destination: ${item.ToCity} - ${item.ToBranch}`,
                toPayData: []
            };
        }

        groupedData[key].toPayData.push({
            isDataRow: true,
            VoucherNo: item.VoucherNo,
            GeneratedDateTime: item.GeneratedDateTime,
            LRNO: item.LRNO,
            FormattedLRNO: item.FormattedLRNO,
            ChallanNo: item.ChallanNo,
            FromCity: item.FromCity,
            FromBranch: item.FromBranch,
            TotalItems: item.TotalItems,
            TopayAmt: item.TopayAmt,
            IsReceived: Number(item.IsReceived),
            isRecValue: Number(item.IsReceived),
            Remarks: item.Remarks,
            remarkValue: item.Remarks
        });
    });
    
    return Object.values(groupedData).map(group => {
        const totalQty = group.toPayData.reduce((sum, row) => sum + row.TotalItems, 0);
        const totalAmount = group.toPayData.reduce((sum, row) => sum + row.TopayAmt, 0);

        group.toPayData.push({
            isTotalRow: true,
            GeneratedDateTime: 'Total',
            TotalItems: totalQty,
            TopayAmt: totalAmount
        });

        return group;
    });
}
